import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

const ErrorFallback = () => {
  // Rien à afficher à l'utilisateur
  return null;
};

const logError = (error, info) => {
  console.error("React Error:", error);
  console.error("Component Stack:", info?.componentStack);

  // Exemple prod
  // Sentry.captureException(error);
};

const ErrorBoundary = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={logError}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
